"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearIdentity = exports.getCurrentIdentity = exports.setCurrentIdentity = exports.isValid = exports.isExpired = void 0;
const types_1 = require("@dcl/crypto/dist/types");
const SSO = __importStar(require("@dcl/single-sign-on-client"));
const Time_1 = __importDefault(require("../date/Time"));
const types_2 = require("../loader/types");
const identify_1 = require("./identify");
const STORE_LEGACY_KEY = 'auth';
let CURRENT_IDENTITY = null;
let CURRENT_IDENTITY_RAW = null;
function isExpired(identity) {
    if (!identity) {
        return true;
    }
    return Time_1.default.date(identity.expiration).getTime() < Date.now();
}
exports.isExpired = isExpired;
function isValid(identity) {
    if (!identity) {
        return false;
    }
    const link = identity.authChain.find((link) => link.type === types_1.AuthLinkType.ECDSA_PERSONAL_EPHEMERAL ||
        link.type === types_1.AuthLinkType.ECDSA_EIP_1654_EPHEMERAL);
    if (link && link.signature && typeof link.signature === 'string') {
        return true;
    }
    return false;
}
exports.isValid = isValid;
function setCurrentIdentity(identity) {
    return __awaiter(this, void 0, void 0, function* () {
        if (identity === null || isExpired(identity) || !isValid(identity)) {
            CURRENT_IDENTITY = null;
            yield storeIdentity(null);
            return null;
        }
        CURRENT_IDENTITY = identity;
        yield storeIdentity(identity);
        return identity;
    });
}
exports.setCurrentIdentity = setCurrentIdentity;
function getCurrentIdentity() {
    return CURRENT_IDENTITY;
}
exports.getCurrentIdentity = getCurrentIdentity;
function storeIdentity(identity) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof localStorage !== 'undefined') {
            // Removes the identity from legacy storage.
            localStorage.removeItem(STORE_LEGACY_KEY);
            localStorage.removeItem(types_2.PersistedKeys.Identity);
            if (identity) {
                // If an identity is provided, store it in the SSO iframe for the account it belongs to.
                const account = yield (0, identify_1.ownerAddress)(identity.authChain);
                yield SSO.storeIdentity(account, identity);
                CURRENT_IDENTITY_RAW = JSON.stringify(identity);
            }
            else {
                CURRENT_IDENTITY_RAW = null;
            }
        }
    });
}
// Clears the identity from SSO.
function clearIdentity() {
    return __awaiter(this, void 0, void 0, function* () {
        if (CURRENT_IDENTITY_RAW) {
            const prevIdentity = JSON.parse(CURRENT_IDENTITY_RAW);
            const account = yield (0, identify_1.ownerAddress)(prevIdentity.authChain);
            yield SSO.clearIdentity(account);
        }
    });
}
exports.clearIdentity = clearIdentity;
